import { render, staticRenderFns } from "./NewFAQ.vue?vue&type=template&id=7ba8ff6c&scoped=true"
import script from "./NewFAQ.vue?vue&type=script&lang=js"
export * from "./NewFAQ.vue?vue&type=script&lang=js"
import style0 from "./NewFAQ.vue?vue&type=style&index=0&id=7ba8ff6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba8ff6c",
  null
  
)

export default component.exports